import { PWAState } from "./types";

export const initialState: PWAState = {
	hasCompletedPWAInit: false
};
